import axios from "axios";
import AxiosInstance1 from "../AxiosInstance/AxiosInstance1";

const GetInitiativeResourceList = async (IdeaId) => {
  const userdata = JSON.parse(sessionStorage.getItem("user"));
  const employeeId = userdata?.employeeId;
  const accessToken = sessionStorage.getItem("access_token");
  try {
    const response = await AxiosInstance1.get(
      `/api/InitiativeDetail/GetInitiativeResourceList`,
      {
        params: { IdeaId }
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error fetching initiative resource list:", error);
    throw new Error("Failed to fetch initiative resource list");
  }
};

export default GetInitiativeResourceList;
